import endpoints from "api/endpoints";
import axiosNeuron from "api/axios";
import { ICompanyList } from "types/company";
import getAnonymizedName from "store/getInitials";

export default async function getCompany(id: number, anonymization?: any) {
  const url = endpoints.companies.detail(id);
  try {
    const response = await axiosNeuron.get(url);
    const data: ICompanyList = response.data;
    const newData = {
      ...data,
      name: anonymization ? getAnonymizedName(data.name) : data.name,
    };
    return newData;
  } catch (error) {
    if (error !== undefined) {
      return null;
    }
  }
}
